module.exports = __webpack_public_path__ + "img/teacher3.108b2d4d.webp";